import React, { useContext } from 'react';
import { Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';

import { StyledLinkedTable } from '../common/tableView.styles';
import { StyledColumn } from '../components/StyledColumn';
import { FetchUsersResponseType } from '../features/candidates/useSearchCandidates';
import { PageRoutesEnum } from '../utils/routes';

import { CandidateDuplicatesContext } from './CandidateDuplicatesContext';
import { LinkTableCell } from './LinkTableCell';

const Title: React.FC = () => (
  <Typography.Title level={5} style={{ paddingLeft: '15px' }}>
    Candidatae duplicates
  </Typography.Title>
);

const useCandidateDuplicatesTableDataSource = (data: FetchUsersResponseType | undefined) => {
  if (!data) {
    return [];
  }

  const dataToMap = data?.results;

  return dataToMap.map((element) => {
    return {
      key: element.uuid,
      uuid: element.uuid,
      firstName: element.firstName,
      lastName: element.lastName,
      email: element.email,
    };
  });
};

type CandidateDuplicateRow = {
  key: string;
  uuid: string;
  firstName: string;
  lastName: string;
  email: string;
};

const useCandidateDuplicatesTableColumnsDefinition = (): ColumnsType<CandidateDuplicateRow> => {
  return [
    {
      title: 'First name',
      dataIndex: 'firstName',
      width: '33%',
      render: (text: string, record) => (
        <LinkTableCell text={text} record={record} pageRoute={PageRoutesEnum.candidateEdit} />
      ),
    },
    {
      title: 'Last name',
      dataIndex: 'lastName',
      width: '33%',
      render: (text: string, record) => (
        <LinkTableCell text={text} record={record} pageRoute={PageRoutesEnum.candidateEdit} />
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      width: '33%',
      render: (text: string, record) => (
        <LinkTableCell text={text} record={record} pageRoute={PageRoutesEnum.candidateEdit} />
      ),
    },
  ];
};

export const CandidateDuplicatesTable: React.FC = () => {
  const { duplicates } = useContext(CandidateDuplicatesContext);

  const columns = useCandidateDuplicatesTableColumnsDefinition();
  const dataSource = useCandidateDuplicatesTableDataSource(duplicates);

  const pagination = {
    pageSize: 5,
    total: duplicates?.count,
    position: ['none', 'bottomCenter'],
    hideOnSinglePage: true,
  };

  return (
    <>
      {dataSource.length > 0 ? (
        <StyledColumn style={{ paddingBottom: '15px' }}>
          <Title />
          <StyledLinkedTable
            columns={columns}
            dataSource={dataSource}
            scroll={{ y: 700 }}
            bordered={true}
            pagination={pagination}
          />
        </StyledColumn>
      ) : (
        <></>
      )}
    </>
  );
};
